module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"candidateInvitation":"Candidate invitation"}}')
  delete Component.options._Ctor
}
